module.exports = __webpack_public_path__ + "static/9c200a14-d264-405c-86bf-d27b840e86be-ede80b55a21b8ce7868cf8d3d8c58ba9.woff";